@if(moduleName === 'location' || moduleName === 'passenger' || moduleName === 'pass_privilege_conf') {
    <form [formGroup]="formName">
        <div class="relative">
            <p-inputNumber [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" [min]="field?.validation?.min" mode="decimal" [useGrouping]="false" class="w-full" [placeholder]="placeholder" [maxFractionDigits]="2"> </p-inputNumber>
            @if(unit){
                <span class="unit right">{{unit}}</span>
            }
        </div>
    </form>
} @else {
    <form [formGroup]="formName">
        <div class="relative">
            <p-inputNumber [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" [min]="field?.validation?.min" mode="decimal" [useGrouping]="false" class="w-full" [placeholder]="placeholder"> </p-inputNumber>
            @if(unit){
                <span class="unit right">{{unit}}</span>
            }
        </div>
    </form>
}
